import { render } from "./Message.vue?vue&type=template&id=486f2c76"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/messages/Message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "486f2c76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('486f2c76', __exports__)) {
    api.reload('486f2c76', __exports__)
  }
  
  module.hot.accept("./Message.vue?vue&type=template&id=486f2c76", () => {
    api.rerender('486f2c76', render)
  })

}


export default __exports__